import { render, staticRenderFns } from "./chooseServe.vue?vue&type=template&id=14974236&scoped=true&"
import script from "./chooseServe.vue?vue&type=script&lang=js&"
export * from "./chooseServe.vue?vue&type=script&lang=js&"
import style0 from "./chooseServe.vue?vue&type=style&index=0&id=14974236&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14974236",
  null
  
)

export default component.exports